/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgUnlockOutline = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.614 9.919a.968.968 0 1 0-1.397.862v1.569h.86v-1.569a.964.964 0 0 0 .537-.862Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.312 1.508a3.198 3.198 0 0 0-3.198 3.198v2.05H3.257l-.5.5v6.732l.5.5h8.78l.5-.5V7.255l-.5-.5H9.113v-2.05a2.198 2.198 0 1 1 4.396 0v.796h1v-.795a3.196 3.196 0 0 0-3.198-3.198ZM3.757 7.755v5.733h7.78V7.755h-7.78Z"
}));

export default SvgUnlockOutline;